/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { defaultData } from '../forecast/detail/reports/user-grid-settings/constants';
import { defaultDetailData } from '../forecast/detail/context/constants';

export type Persistor<T> = T & {
  instance: T;
};

export class DefaultStorage implements Storage {
  private data: {[key: string]: string};

  constructor() {
    this.data = { ...defaultData, ...defaultDetailData };
  }

  public getItem(key: string): string {
    return this.data[key];
  }

  public clear() {
    this.data = { ...defaultData, ...defaultDetailData };
  }

  public setItem(key: string, value: string) {
    this.data[key] = value;
  }

  public removeItem(key: string) {
    delete this.data[key];
  }

  public key(keyIndex: number) {
    return Object.keys(this.data)[keyIndex];
  }

  get length() {
    return Object.keys(this.data).length;
  }
}
